export default "__VITE_ASSET__870717ea__"